import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncFestivalFAQ({ ...rest }) {
  const AsyncLoad = loadable(() => import("../frontend/faq/page/FestivalFAQ"));
  console.log("Loading", AsyncFestivalFAQ.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncFestivalFAQ;
